import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

/**
 * Component breadcrumb navigation cho trang chi tiết tuyển dụng
 * @param {Object} recruitment - Thông tin vị trí tuyển dụng
 */
function JobDetailNav(props) {
    const {recruitment} = props;
    const {locale} = useRouter();

    console.log(recruitment);

    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {
                        label: getLocaleContent(locale, 'page.recruitment.nav_title') || 'TUYỂN DỤNG',
                        href: '/tuyen-dung',
                        color: '#006940',
                    },
                    {
                        label:
                            locale === 'en'
                                ? recruitment?.recruitment_name_en || recruitment?.department_name_en || 'Job Details'
                                : recruitment?.recruitment_name ||
                                  recruitment?.department_name ||
                                  'Chi tiết tuyển dụng',
                    },
                ]}
            />
        </div>
    );
}

export default JobDetailNav;
